import Modal from "../Modal/Modal";
import { getComposedMenus } from "../../features/orderUtils";
import "./OrderItemsModal.scss";

// title            – voliteľný nadpis modalu (napr. pre súhrn za obdobie)
// showComposedMenus – zložené menu dáva zmysel len pri jednej objednávke;
//                     pri agregovanom súhrne sa vypína
function OrderItemsModal({
  isOpen,
  onClose,
  order,
  title = "Položky objednávky",
  showComposedMenus = true,
}) {
  const items = order?.items || [];
  const composedMenus = showComposedMenus ? getComposedMenus(items) : [];

  return (
    <Modal isOpen={isOpen} onClose={onClose} title={title}>
      <div className="order-items-modal">
        {items.filter(item => item.quantity > 0).map((item, index) => (
          <div key={index} className="order-items-modal__row">
            <span className="order-items-modal__qty">{item.quantity}x</span>
            {item.menu_code && (
              <strong className="order-items-modal__code">{item.menu_code}</strong>
            )}
            <span className="order-items-modal__name">{item.name}</span>
          </div>
        ))}
        {composedMenus.length > 0 && (
          <>
            <div className="order-items-modal__section-title">Zložené menu</div>
            {composedMenus.map(({ label, count, soupName, mainName }) => (
              <div key={label} className="order-items-modal__row order-items-modal__row--combo">
                <span className="order-items-modal__qty">{count}x</span>
                <strong className="order-items-modal__code">{label}</strong>
                <span className="order-items-modal__name">{soupName} + {mainName}</span>
              </div>
            ))}
          </>
        )}
      </div>
    </Modal>
  );
}

export default OrderItemsModal;